export const response_create_punto_expedicion = {
  description: 'Punto de expedición creado',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string', example: 'Punto de expedicion creado exitosamente' },
      data: {
        type: 'object',
        properties: {
          id: { type: 'string', example: 'b7b3f2ab-...' },
          empresa_id: { type: 'string', example: 'cd88ac6a-...' },
          sucursal_id: { type: 'string', example: '1a2b3c4d-...' },
          punto_expedicion: { type: 'string', example: '001' },
          tipo_documento_id: { type: 'string', example: '408ba837-...' },
          num_inicial: { type: 'string', example: '0000001' },
          descripcion: { type: 'string', example: 'Caja central' },
          eslogan: { type: 'string', example: 'Siempre cerca' },
          usuario: { type: 'string', example: 'admin' },
        },
      },
    },
  },
};

export const response_punto_expedicion_find = {
  description: 'Punto de expedición enco    ntrado',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string', example: 'Punto de expedicion encontrado exitosamente' },
      data: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          empresa_id: { type: 'string' },
          sucursal_id: { type: 'string' },
          punto_expedicion: { type: 'string' },
          tipo_documento_id: { type: 'string' },
          num_inicial: { type: 'string' },
          descripcion: { type: 'string' },
          eslogan: { type: 'string' },
          usuario: { type: 'string' },
        },
      },
    },
  },
};

export const response_punto_expedicion_all = {
  description: 'Puntos de expedición obtenidos exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string' },
      data: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: { type: 'string' },
            empresa_id: { type: 'string' },
            sucursal_id: { type: 'string' },
            punto_expedicion: { type: 'string' },
            tipo_documento_id: { type: 'string' },
            num_inicial: { type: 'string' },
            descripcion: { type: 'string' },
            eslogan: { type: 'string' },
            usuario: { type: 'string' },
          },
        },
      },
      total: { type: 'number' },
      page: { type: 'number' },
      limit: { type: 'number' },
      lastPage: { type: 'number' },
    },
  },
};
